import React from 'react';
import { cn } from './cn';

/**
 * TierPill — Free / Premium / Trial. Used in Sessions, Card Decks, Banners,
 * App Users.
 *
 * Sessions schema: `session_is_free` (boolean). When false the session is
 * premium. The component accepts either an explicit tone ("premium"/"free"/
 * "trial") or `isFree` for that boolean shortcut.
 */
const TONE = {
  free:    'bg-cream text-text-muted border border-sand',
  premium: 'bg-coral text-white',
  trial:   'bg-[#FCEAD1] text-[#8C5A1E]',
};

export function TierPill({ tone, isFree, children, className }) {
  const resolvedTone = tone || (isFree ? 'free' : 'premium');
  const label = children ?? (resolvedTone === 'free' ? 'Free' : resolvedTone === 'premium' ? 'Premium' : 'Trial');
  return (
    <span
      className={cn(
        'inline-flex items-center font-condensed font-bold text-[10px]',
        'uppercase tracking-wider rounded-pill px-2 py-0.5 whitespace-nowrap',
        TONE[resolvedTone],
        className,
      )}
    >
      {label}
    </span>
  );
}

export default TierPill;
